const BlogContent2 = [
    {
        image: '/assets/images/proof/ice-rex-screenshot.png',
        category: 'Internal Platform',
        title: 'ICE / REX — Enterprise Agents',
        ref: '/recent-work#ice-rex',
        description: 'Intelligent Co-worker for Enterprise: generative AI system with curated enterprise data, secure private tenant, and embedded sales operations (REX).'
    },
    {
        image: '/assets/images/proof/rita-screenshot.png',
        category: 'Internal Platform',
        title: 'RITA — IT Self-Service Assistant',
        ref: '/recent-work#rita',
        description: 'IT service assistant built under FAIR for password resets, hardware/software requests, IT policy Q&A with source-document citations.'
    },
    {
        image: '/assets/images/proof/palantir-screenshot.png',
        category: 'Platform Partnerships',
        title: 'Sema4.ai & Palantir Foundry/AIP',
        ref: '/recent-work#palantir',
        description: 'Forward-deployed engagements embedded with stakeholders, translating workflows into production systems with governance and security.'
    },
    {
        image: '/assets/images/proof/legalmind-screenshot.png',
        category: 'AWS Marketplace',
        title: 'LegalMind — Contract Intelligence',
        ref: '/enterprise-ai#legalmind',
        description: 'Bedrock-powered legal copilot for contract extraction and obligation/risk Q&A with citations, prepared for AWS Marketplace.'
    },
    {
        image: '/assets/images/proof/careflow-screenshot.png',
        category: 'AWS Marketplace',
        title: 'Careflow — Ambient Clinical Documentation',
        ref: '/enterprise-ai#careflow',
        description: 'HIPAA-ready agentic platform using Bedrock + Nova Sonic for real-time speech-to-speech clinical encounters and follow-up workflows.'
    },
    {
        image: '/assets/images/proof/healthbridge-guardrails.svg',
        category: 'AWS Marketplace',
        title: 'HealthBridge — Agent Navigator',
        ref: '/enterprise-ai#healthbridge',
        description: 'Guardrail-first agent runtime powered by Nova Act with dry-run defaults, controlled mutations, and audit-friendly status tracking.'
    }
]

export default BlogContent2;
